import Counter from "$components/Counter";
import React from 'react';
export default {
  Counter,
  React
};